import FullLogo from "./images/KivuFMS.png";
import WelcomeAboutSideImage from "./images/welcome-about-side.png";

export const ImsLogo = FullLogo;
export const KivuFMSLogo = FullLogo;
export const welcomeAboutSideImage = WelcomeAboutSideImage;
